import React, { useState, useMemo, useCallback, useRef } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import BurgerIcon from '../../../Icons/Burger';
import { BiEventType, BiLink } from '../../../biLogger';
import SearchButton from '../SearchButton';
import SubmitMenu from './SubmitMenu';
import { useBodyScrollLock } from '../../../utils/hooks/useBodyScollLock';
import { useOnOutsideClick } from '../../../utils/hooks/useOnOutsideClick';
import s from './BurgerMenu.scss';
var BurgerMenu = function (_a) {
    var activeMainMenuItem = _a.activeMainMenuItem, watchCount = _a.watchCount, _b = _a.isLegacyHeader, isLegacyHeader = _b === void 0 ? false : _b, pushModal = _a.pushModal, isLoggedIn = _a.isLoggedIn, onOpenMobileSearch = _a.onOpenMobileSearch;
    var _c = useState(false), isBurgerMenuOpened = _c[0], setBurgerMenuOpened = _c[1];
    var _d = useState(false), isSubmitMenuOpened = _d[0], setSubmitMenuOpened = _d[1];
    var rootRef = useRef(null);
    var _e = useBodyScrollLock(), onLock = _e.onLock, onUnlock = _e.onUnlock, setScrollableRef = _e.setScrollableRef;
    var t = useTranslation().t;
    var showBurgerMenu = useCallback(function () {
        onLock();
        setBurgerMenuOpened(true);
        setSubmitMenuOpened(false);
    }, [onLock]);
    var hideBurgerMenu = useCallback(function () {
        onUnlock();
        setBurgerMenuOpened(false);
        setSubmitMenuOpened(false);
    }, [onUnlock]);
    var toggleSubmitMenu = useCallback(function () {
        setSubmitMenuOpened(!isSubmitMenuOpened);
    }, [isSubmitMenuOpened]);
    var handleClickSearchButton = useCallback(function () {
        hideBurgerMenu();
        onOpenMobileSearch();
    }, [hideBurgerMenu, onOpenMobileSearch]);
    var toggleBurgerMenu = function () {
        return isBurgerMenuOpened ? hideBurgerMenu() : showBurgerMenu();
    };
    useOnOutsideClick(rootRef, hideBurgerMenu);
    var menuItems = useMemo(function () { return [
        {
            key: 'siteHeader.browse',
            url: Url.browseHomeLink(),
        },
        isLoggedIn && {
            key: 'siteHeader.watch',
            notification: watchCount > 0,
            url: Url.watchLink(),
        },
        {
            key: 'siteHeader.groups',
            url: URLS.GROUPS,
        },
        {
            key: 'siteHeader.forum',
            url: URLS.FORUM,
        },
        {
            key: 'siteHeader.helpAndFAQ',
            url: URLS.HELP,
        },
    ]; }, [isLoggedIn, watchCount]);
    return (React.createElement("div", { ref: rootRef, className: classnames(s['burger-menu-wrapper'], isBurgerMenuOpened && s['is-opened']) },
        React.createElement("div", { className: s['burger-menu-shade'], onClick: toggleBurgerMenu }),
        React.createElement("div", { className: s['burger-icon-button'], onClick: toggleBurgerMenu },
            React.createElement(BurgerIcon, { className: s['burger-icon'], disableDefaultColors: true })),
        React.createElement("div", { className: s['burger-menu'], ref: setScrollableRef },
            React.createElement("div", { className: s['burger-search-button'] },
                React.createElement(SearchButton, { className: s['icon-button'], iconClassName: s['search-icon'], onClick: handleClickSearchButton })),
            React.createElement("ul", { className: classnames(s['main-menu'], isSubmitMenuOpened && s['list-items--disabled']) }, menuItems.map(function (menuItem) {
                return menuItem && (React.createElement("li", { key: menuItem.key },
                    React.createElement(BiLink, { biData: {
                            evid: BiEventType.TOP_NAV_CLICK,
                            link_url: menuItem.url,
                            link_name: menuItem.key.split('.')[1],
                            indicator: typeof menuItem.notification !== 'undefined'
                                ? Number(menuItem.notification)
                                : undefined,
                        }, href: menuItem.url, className: classnames(s['list-item'], menuItem.key === activeMainMenuItem && s['active']) },
                        React.createElement("span", { className: classnames(menuItem.notification && s['notification']) }, t(menuItem.key)))));
            })),
            React.createElement(SubmitMenu, { isOpen: isSubmitMenuOpened, isLegacyHeader: isLegacyHeader, pushModal: pushModal, onToggle: toggleSubmitMenu }))));
};
export default BurgerMenu;
//# sourceMappingURL=BurgerMenu.experimental_body_scroll_lock.js.map